import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

export const selectFindHojaDeCargo = createSelector(
    [(store: RootState) => store.supervisorDocumentsList.datosHojaDeCargo],
    (datosHojaDeCargo) => datosHojaDeCargo
);